import type { PhoneData } from 'src/functions/formatPhone/types'

export default function getRawPhone(
  phone: string,
  phoneData: PhoneData | null,
) {
  const prepearedPhone = phone.replace(/[^()0-9,;/]/g, '')
    .split(/[,;/]/)
    .map(i => i
      .replace(/\(\d+\)$/g, '')
      .replace(/[^0-9]/g, ''))
    .sort((a, b) => a.length - b.length)
    .pop()!

  if (!phoneData) {
    return prepearedPhone
  }

  const rawPhone = prepearedPhone.slice(-phoneData.length)

  if (rawPhone.length !== phoneData.length) {
    return prepearedPhone
  }

  const prefix = phoneData.getPrefix
    ? phoneData.getPrefix(rawPhone, phoneData.code)
    : phoneData.code

  return `${prefix}${rawPhone}`
}
